<template>
<div>
    <div class="breadcrumbs" id="breadcrumbs">
      <span class="breadcrumb-link">Preferences</span> &gt;
      <router-link class="breadcrumb-link" to="/settings/team">Team Settings</router-link>
    </div>
    <h3>Team Settings</h3>
    <div class="large-form">
        <div class="form-line">
            <div class="form-line-fields">
                <div id="form-field-name" class="form-field">
                    <label for="name">Team Name</label>
                    <input v-model="teamCopy.name" type="text" name="name" required="required" placeholder="My Team" />
                </div>
            </div>
            <div class="form-line-desc">Your team name is displayed on your campaingn pages.</div>
        </div>
        <div class="form-line">
            <div class="form-line-fields">
                <div id="form-field-team-slug" class="form-field">
                    <label for="form-input-team-slug">Team Slug</label>
                    <div v-if="['bb_admin','manager'].includes(user.role)">
                      <span>{{ hubBaseUrl }}/pick-a-gift/</span><input v-model="teamCopy.slug" type="text" id="form-input-team-slug" required="required" placeholder="my-team" />
                    </div>
                    <div v-if="!['bb_admin','manager'].includes(user.role)">
                      <span>{{ hubBaseUrl }}/pick-a-gift/{{ team.slug }}</span>
                      <br /><i>Only Team Managers can change the team slug.</i>
                    </div>
                </div>
            </div>
            <div class="form-line-desc">Your team slug is a part of the URL that identifies your team. All your campaign gift selection pages start with your team slug.</div>
        </div>

        <div class="form-line">
            <div class="form-line-fields">
                <div id="form-field-logo" class="form-field" style="width: 25%">
                    <label>Team Logo</label>
                    <div v-if="team.logo_url"><img :src="team.logo_url" alt="Team logo" class="team-logo-image"></div>
                    <div @click="onUploadBtnClick('logo_url')" class="ws-button ws-button-secondary">{{ team.logo_url ? 'Update' : 'Upload'}} Logo</div>
                    <input ref="logoUploadInput" accept="image/*" style="display: none" type="file" @change="uploadImage('logo_url',$event)">
                </div>
            </div>
        </div>

        <div class="form-line" v-if="!demo.isDemo && team.plan=='pro'">
            <div class="form-line-fields">
                <div id="form-field-domains" class="form-field">
                    <label>Eligible domains</label>
                    <table class="worksends-table inset">
                        <thead>
                        <tr>
                            <th>Domain</th>
                            <th v-if="['bb_admin','manager'].includes(user.role)">Actions</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="item in team.domains" :key="item">
                            <td class="field-name"><div class="value">{{ item }}</div></td>
                            <td class="field-actions" v-if="['manager', 'bb_admin'].includes(user.role)"><div class="value"><a @click="deleteDomain(item)" class="ws-button ws-button-negative small">Remove</a></div></td>
                        </tr>
                        </tbody>
                    </table>
                    <div v-if="['bb_admin','manager'].includes(user.role)">
                        <label>Add New Eligible Domain</label>
                        <div class="form-field" style="width:85%">
                            <input v-model="domainInput.domain" type="text" placeholder="Domain e.g. your-team.com"/>
                        </div>
                        <div class="form-field" style="width: 15%">
                            <div @click="addDomain" class="ws-button ws-button-secondary" href="#">Add</div>
                        </div>
                        <p v-for="e in domainInput.errors" class="form-field error-text">{{ e[0] }}</p>
                    </div>
                </div>
            </div>
            <div class="form-line-desc"><br />Customers have to be registered with email addresses within your eligible domains to be able to register for gifts, redeem vouchers or order your team products.</div>
        </div>

        <div @click="updateSettings" class="ws-button ws-button-primary">Update Team Settings</div>
      </div>
</div>
</template>

<script>
import { hubBaseUrl } from '@/utils/hub-url';

export default {
    name: "SettingsTeam",
    data() {
        return {
            domainInput: {domain:'', errors:[]},
            hubBaseUrl,
        }
    },
    methods: {
        async fetchData() {
        },
        async uploadImage(field,event) {
            if (!this.demoCheck()) return;
            
            const formData = new FormData();
            formData.append("file", event.target.files[0]);
            formData.append("type", field);
            await this.dispatchWaitAndNotify('uploadTeamImage', formData, false, true);
        },
        async addDomain() {
            if (!this.demoCheck()) return;
            
            this.domainInput.errors = this.validateFields([
                { name: 'Domain', value: this.domainInput.domain, rules: ['required', 'domain'] },
            ])
            if (this.domainInput.errors.length) {
                return;
            }
            await this.dispatchWaitAndNotify('addTeamDomain', { domain: this.domainInput.domain });
            this.domainInput.domain = "";
        },
        deleteDomain(domain) {
            if (!this.demoCheck()) return;
            
            this.dispatchWaitAndNotify('deleteTeamDomain', { domain });
        },
        onUploadBtnClick(what) {
            if (!this.demoCheck()) return;
            if (what=='logo_url') this.$refs.logoUploadInput.click();
            //if (what=='hero_url') this.$refs.heroUploadInput.click();
        },
        updateSettings() {
            if (!this.demoCheck()) return;
            
            this.dispatchWaitAndNotify('updateTeam', this.teamCopy);
        },
    },
    mounted() {
        this.fetchData();
    },
    computed: {
        team() {
            return this.$store.state.team.detail;
        },
        teamCopy() {
            return this.$store.state.team.detailCopy;
        },
        user() {
            return this.$store.state.currentUser;
        },
        emailCategories() {
            return this.$store.state.emailCategories;
        },
        modals() {
            return this.$store.state.modals;
        },
        stripePaymentMethods() {
            return this.$store.state.transaction.stripePaymentMethods;
        },
        demo() {
            return this.$store.state.demo;
        },
    }
}
</script>
